import { render, staticRenderFns } from "./PurimUpdateStudent.vue?vue&type=template&id=7d0c3f50&"
import script from "./PurimUpdateStudent.vue?vue&type=script&lang=js&"
export * from "./PurimUpdateStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports